import React from 'react';

export const defaultContextValue = { dataSource: null, defaultVariables: null };

const QueryContext = React.createContext(defaultContextValue);

export default QueryContext;
